import type { BoundsType } from '@/components/pages/token-transparency/token-transparency.model';

export const determineScoreClasses = (value: number, bounds: BoundsType): string => {
    const defaultClasses =
        'flex text-center items-center text-xs w-10 h-10 rounded-3xl justify-center hover:opacity-80 border text-white';
    const { min, max } = bounds;

    if (isNaN(value) || isNaN(min) || isNaN(max) || max <= min) {
        return `${defaultClasses} bg-red-300 border-red-300`;
    }

    const clampedValue = Math.max(min, Math.min(value, max));

    const range = max - min;
    const normalizedValue = (clampedValue - min) / range;

    if (normalizedValue < 0.12) {
        return `${defaultClasses} bg-red-400 border-red-500 hover:border-red-600`;
    } else if (normalizedValue < 0.25) {
        return `${defaultClasses} bg-red-500 border-red-600 hover:border-red-700`;
    } else if (normalizedValue < 0.35) {
        return `${defaultClasses} bg-orange-400 border-orange-500 hover:border-orange-600`;
    } else if (normalizedValue < 0.5) {
        return `${defaultClasses} bg-orange-500 border-orange-600 hover:border-orange-700`;
    } else if (normalizedValue < 0.65) {
        return `${defaultClasses} bg-yellow-400 border-yellow-500 hover:border-yellow-600`;
    } else if (normalizedValue < 0.8) {
        return `${defaultClasses} bg-yellow-500 border-yellow-600 hover:border-yellow-700`;
    } else if (normalizedValue < 0.98) {
        return `${defaultClasses} bg-green-400 border-green-500 hover:border-green-600`;
    } else {
        return `${defaultClasses} bg-green-500 border-green-600 hover:border-green-700`;
    }
};
